import React from "react";
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import ProjectService from "../../services/projects";

class SearchProject extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = { selectedProject: undefined, search: '' };
    }

    reactivateProject = (projectID) => {
        ProjectService.get(projectID)
            .then(retProject => {
                retProject.inactive = false;
                ProjectService.save(retProject);
            }, err => { console.log(err) })

    }
    search = (ev) => {
        this.setState({ search: ev.target.value.toLowerCase() });
    }
    handleClose = () => {
        this.props.onClose();
    }

    handleSave = (project) => {
        this.props.save(project);
        if (project.inactive === true) {
            this.reactivateProject(project._id);
        }
    }

    compare(a, b) {
        if (a.name < b.name)
            return -1;
        if (a.name > b.name)
            return 1;
        return 0;
    }
    render() {
        let count = 0;
        let recentList = this.props.projects.map((project) => {
            count++;
            if (count < 6) {
                return <div key={project._id} onClick={() => this.handleSave(project)}><FormControlLabel key={project._id} value="{project._id}" control={<Radio key={project._id} />} label={project.projectnumber + ' - ' + project.name + ', ' + (project.client ? project.client.name : '')} /><br /></div>;
            } else {
                return ''
            }
        })

        let projectList = this.props.projects.map((project) => {
            if (String(project.name).toLowerCase().indexOf(this.state.search) >= 0 || String(project.projectnumber).toLowerCase().indexOf(this.state.search) >= 0 || String(project.description).toLowerCase().indexOf(this.state.search) >= 0 || (project.client ? project.client.name : '').toLowerCase().indexOf(this.state.search) >= 0) {
                return <div key={project._id} onClick={() => this.props.save(project)}><FormControlLabel key={project._id} value="{project._id}" control={<Radio key={project._id} />} label={project.projectnumber + ' - ' + project.name + ', ' + (project.client ? project.client.name : '')} /><br /></div>;
            } else {
                return '';
            }
        })
        return (
            <div>
                <Dialog
                    fullScreen
                    open={true}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title"
                >
                    <DialogTitle id="form-dialog-title">Zoeken naar project</DialogTitle>
                    <DialogContent style={{ minWidth: '400px' }}>
                        <DialogContentText>

                        </DialogContentText>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="remark"
                            label="Zoek op project nummer of naam"
                            type="text"
                            value={this.state.message}
                            onChange={this.search}
                            fullWidth
                        />
                        <br />
                        {this.state.search.length > 0 && projectList}

                        {this.state.search.length === 0 &&
                            <div>
                                <b>Recente projecten</b>
                                {recentList}
                                <br/>
                                <b>Alle projecten</b>
                                {projectList}
                            </div>
                        }

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="secondary">
                            Annuleren
                         </Button>

                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}
export default SearchProject;
